import script from "./ImagesUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagesUploader.vue?vue&type=script&setup=true&lang=ts"

import "./ImagesUploader.vue?vue&type=style&index=0&id=6e26ef04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e26ef04"]])

export default __exports__